// extracted by mini-css-extract-plugin
export var active = "_la-e";
export var blink = "_la-f";
export var dropDownSelector = "_la-5";
export var dropDownWrapper = "_la-4";
export var fakeCursor = "_la-d";
export var fontSizeButton = "_la-7";
export var formQuillEditor = "_la-0";
export var pressed = "_la-g";
export var qlBlank = "_la-1";
export var textFormattingToolbar = "_la-2";
export var textFormattingToolbarClosed = "_la-3";
export var textFormattingToolbarInline = "_la-6";
export var textToolbarOption = "_la-8";
export var toolbarCell = "_la-a";
export var toolbarCellCollapsed = "_la-b";
export var toolbarOptionHitArea = "_la-c";
export var toolbarOverflow = "_la-9";